<template>
  <div>
    <PageAllow controller="Suppliers" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color" v-show="!currentItemMode">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="keyword = $event"
                :label="$t('Supplier.Keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 售后批量打分 -->
              <v-btn
                v-if="(settings && settings.supplier_score_enable) && $permission.permissionAllow('Suppliers', 'scoreBatchSave')"
                small
                dark
                color="primary"
                class="ms-1"
                @click.stop="scoreBatchDialog = true"
              >
                {{ $t("SupplierScoreBatch.title") }}
              </v-btn>
              <!-- 供应商评分标准 -->
              <v-btn
                v-if="(settings && settings.supplier_score_enable) && $permission.permissionAllow('Suppliers', 'criteriaSetting')"
                small
                dark
                color="orange"
                class="ms-1"
                @click.stop="$router.push('/supplier/criteria-setting')"
              >
                {{ $t("SupplierCriteriaSetting.btn") }}
              </v-btn>
              <!-- 添加 -->
              <v-btn
                v-if="
                  settings &&
                  settings.push_platform != 1018 &&
                  settings.push_platform <= 2000 &&
                  !sync_supplier_data_from && // 有三方对接但基础信息以本地录入形式处理
                  $permission.permissionAllow('Suppliers', 'add')
                "
                small
                color="primary"
                @click.stop="currentItemMode = 'new'"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("Supplier.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  (settings.push_platform == 1018 ||
                    settings.push_platform > 2000 || 
                    sync_supplier_data_from) &&
                  $permission.permissionAllow('Suppliers', 'add')
                "
                small
                dark
                color="warning"
                class="ms-1"
                @click.stop="syncKingdeeSuppliers()"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Supplier.actions.syncWithKingdee") }}
              </v-btn>
              <v-btn
                  v-if="settings && settings.sync_third_base_suppliers && settings.sync_third_base_suppliers == 1"
                  small
                  dark
                  color="warning"
                  class="ms-1"
                  @click.stop="syncThirdSupplier()"
                >
                  <v-icon x-small class="pe-1">fa-sync</v-icon>
                  {{ $t("Supplier.actions.syncThirdSupplier") }}
              </v-btn>
              <v-btn
                  v-if="$permission.permissionAllow('Suppliers', 'import')"
                  small
                  color="print"
                  dark
                  @click.stop="ImportExcelDialog = true"
                  class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Supplier.Import.title") }}
              </v-btn>
              <v-btn
                  v-if="$permission.permissionAllow('Suppliers', 'supplierExport')"
                  small
                  color="print"
                  dark
                  @click="exports()"
                  class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Supplier.export") }}
              </v-btn>
              <v-btn
                  v-if="settings && settings.shop_third_account == 1"
                  small
                  dark
                  color="orange"
                  class="ms-1"
                  @click.stop="syncYongYouData()"
                >
                  {{ $t("Supplier.syncYongYouData") }}
                </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="district_keyword"
                    v-model="options.district_keyword"
                    @text="districtKeyword = $event"
                    :label="$t('Supplier.districtKeyword')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" class="mt-8">
                  <!-- 是否开启订单转采购 -->
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Supplier.orderToPurchase.title") }}
                  </div>
                  <v-radio-group row v-model="options.order_to_purchase">
                    <v-radio
                      :label="$t('Supplier.orderToPurchase.all')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('Supplier.orderToPurchase.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('Supplier.orderToPurchase.off')"
                      :key="2"
                      :value="2"
                    />
                  </v-radio-group>
                  <!--                  <SearcherSupplyType v-model="options.type" />-->
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  class="mt-8"
                  v-if="settings && settings.supplier_expire_show_flg"
                >
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Supplier.contractStatus.title") }}
                  </div>
                  <v-radio-group row v-model="options.licence_date">
                    <v-radio
                      :label="$t('Supplier.contractStatus.all')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('Supplier.contractStatus.in')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('Supplier.contractStatus.out')"
                      :key="2"
                      :value="2"
                    />
                  </v-radio-group>
                </v-col>
                <!-- 供应商分区 -->
                <v-col cols="12" sm="6" md="4" class="mt-8" v-if="settings && settings.account_supplier">
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Supplier.SupplyType.ObjectName") }}
                  </div>
                  <v-radio-group row v-model="options.SupplierType">
                    <v-radio
                      :label="$t('Supplier.SupplyType.all')"
                      :key="-1"
                      :value="-1"
                    />
                    <v-radio
                      :label="$t('Supplier.SupplyType.common')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('Supplier.SupplyType.platform')"
                      :key="2"
                      :value="2"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="suppliers"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.supply_type="{ item }">
              {{ item.supply_type }}
              <br />
              <span
                v-if="item.order_to_purchase == 1"
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ $t("Supplier.Fields.order_to_purchase") }}
              </span>
            </template>
            <template v-slot:item.stop_flg="{ item, index }">
              <!-- 状态文字/颜色 -->
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>

              <v-chip
                small
                label
                :color="item.stop_flg | stopFlgColor"
                :text-color="item.stop_flg | stopFlgTextColor"
              >
                {{ item.stop_flg | stopFlgText }}
              </v-chip>
              <br />
              <span class="red--text" v-if="item.show_licence_notice">
                {{ $t("Supplier.Fields.licence_notice") }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 明细 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Suppliers', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="info"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("Supplier.actions.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("Supplier.actions.detail")])
                }}</span>
              </v-tooltip>
              <!-- 采购TODO: 缺接口 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Suppliers', 'purchase')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("Supplier.actions.purchases") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("Supplier.actions.purchases")])
                }}</span>
              </v-tooltip>
              <!-- 编辑 -->
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Suppliers', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                    {{ $t("Supplier.actions.edit") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("Supplier.actions.edit")])
                }}</span>
              </v-tooltip>
              <!-- 删除 -->
              <v-tooltip
                top
                v-if="
                  item.delete_enable == 1 &&
                  $permission.permissionAllow('Suppliers', 'delete')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="danger"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                  >
                    <v-icon x-small class="pe-1">fa-exclamation</v-icon>
                    {{ $t("Supplier.actions.delete") }}
                  </v-btn>
                </template>
                <span>{{ $t("Supplier.actions.delete") }}</span>
              </v-tooltip>
              <!-- 售后打分日志 -->
              <v-tooltip
                top
                v-if="
                  settings &&
                  settings.supplier_score_enable &&
                  $permission.permissionAllow('Suppliers', 'scoreLogs')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      currentItem = item;
                      scoreLogsDialog = true;
                    "
                  >
                    {{ $t("Supplier.actions.scoreLogs") }}
                  </v-btn>
                </template>
                <span>{{ $t("Supplier.actions.scoreLogs") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 删除 -->
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Supplier.ObjectName')"
      @confirm="
        deleteContainer();
        deleteDialog = false;
      "
    />
    <ImportExcelAlert
      v-model="ImportExcelDialog"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportExcelResult
      v-model="ImportExcelResultDialog"
      :errorSupplier="errorSupplier"
    />
    <!-- 操作跳转 -->
    <SupplierDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="
        getSupplierFromAPI()
        currentItem = null;
        currentItemMode = null;
      "
    />

    <DialogSupplierScore v-model="scoreBatchDialog" />

    <DialogSupplierScoreLog v-model="scoreLogsDialog" :data="currentItem" />
    <DialogAlert
      v-model="YongYouDataDialog"
      :message="$t('Supplier.syncYongYouDataAlert')"
      bold
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Suppliers from "@/api/suppliers";
// import SearcherSupplyType from "@/components/plugins/SearcherSupplyType";
// import SearcherStatus from "@/components/plugins/SearcherStatus";
import SupplierDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import KingdeeWorker from "@/api/kingdee_worker";
import YywdMiddleware from "@/api/yywd_middleware";
import YywdNewMiddleware from "@/api/yywd_new_middleware";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import ImportExcelResult from "./plugins/ImportExcelResult";
import DialogSupplierScore from "./plugins/DialogSupplierScore";
import DialogSupplierScoreLog from "./plugins/DialogSupplierScoreLog";
import DialogAlert from "@/components/plugins/DialogAlert";

const defaultOptions = {
  keyword: "",
  "district_keyword": "",
  licence_date: 0,
  order_to_purchase: 0,
  show_licence_notice: 0,
  SupplierType: -1,
};

export default {
  data: () => ({
    suppliers: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("suppliers-options")
        ? sessionStorage.getItem("suppliers-options")
        : JSON.stringify(defaultOptions)
    ),
    keyword: "",
    districtKeyword: "",
    currentItemMode: null,
    currentItem: null,
    initialize: 0,
    deleteDialog: false,
    ImportExcelDialog: false,
    scoreBatchDialog: false,
    scoreLogsDialog: false,
    ImportExcelResultDialog: false,
    errorSupplier: [],
    YongYouDataDialog: false,
  }),
  components: {
    Breadcrumbs,
    SearcherKeyword,
    PageAllow,
    // SearcherSupplyType,
    DialogDelete,
    SupplierDetail,
    ImportExcelAlert,
    ImportExcelResult,
    DialogSupplierScore,
    DialogSupplierScoreLog,
    DialogAlert,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.supplier"),
        disabled: true,
        href: "/supplier",
      },
    ],
    headers: () => [
      {
        text: i18n.t("Supplier.Fields.supplier_code"),
        align: "start",
        sortable: false,
        value: "supplier_code",
      },
      {
        text: i18n.t("Supplier.Fields.supplier_name"),
        align: "start",
        sortable: false,
        value: "supplier_name",
      },
      {
        text: i18n.t("Supplier.Fields.supply_type"),
        align: "start",
        sortable: false,
        class: "text-no-wrap",
        value: "supply_type",
      },
      {
        text: i18n.t("Supplier.Fields.district_name"),
        align: "start",
        sortable: false,
        value: "district.name",
      },
      {
        text: i18n.t("Supplier.Fields.manager_name"),
        align: "start",
        sortable: false,
        value: "manager_name",
      },
      {
        text: i18n.t("Supplier.Fields.manager_tel"),
        align: "start",
        sortable: false,
        value: "manager_tel",
      },
      {
        text: i18n.t("Supplier.Fields.status"),
        align: "center",
        sortable: false,
        value: "stop_flg",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["loading", "settings", "sync_supplier_data_from", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("suppliers", ["stocksContainersSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksContainersSelected":
                this.stocksContainersSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
        district_keyword: this.districtKeyword
      });
    },
    importExcel() {
      Suppliers.Import(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (!response.data.isErrorFlg) {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("Supplier.ObjectName")])
                );
                this.ImportExcelDialog = false;
                this.getSupplierFromAPI();
              } else {
                this.errorSupplier = response.data.errorSupplier;
                this.ImportExcelDialog = false;
                this.ImportExcelResultDialog = true;
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    resetSearch() {
      //   this.stocksContainersSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword, this.$refs.district_keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    getSupplierFromAPI() {
      this.currentItemMode = null;
      this.currentItem = null;

      let postData = JSON.parse(JSON.stringify(this.options));
      //   this.id = this.$route.query.stock_id;
      if (this.settings && !this.settings.supplier_expire_show_flg) {
        delete postData.licence_date;
        delete postData.show_licence_notice;
      } else if (this.settings && this.settings.supplier_expire_show_flg) {
        postData.show_licence_notice = this.settings.supplier_expire_show_flg;
      }
      if (postData.SupplierType == -1) {
        delete postData.type;
      }else {
        postData.type = postData.SupplierType
      }
      Suppliers.fetch(postData).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.suppliers = response.data.suppliers;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    // 弹窗 确认删除
    deleteContainer() {
      this.$store.dispatch("fullscreenLoading");
      if (this.currentItem) {
        Suppliers.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.getSupplierFromAPI();
            }else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        ).catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
    syncKingdeeSuppliers() {
      this.$store.dispatch("fullscreenLoading");
      if (this.settings.push_platform == 1018)
        KingdeeWorker.addJob({
          event: "sync_suppliers",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Supplier.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      else if (this.sync_supplier_data_from > 0) {
        var ev = null;
        switch(this.sync_supplier_data_from) {
          case 1:// 金蝶
            ev = "sync_kingdee_suppliers";
            break;
        }
        if (ev == null) return;//万一有配置错误就不推送任务了
        YywdNewMiddleware.addJob({
            event: ev,
            param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
          }).then(
            function (response) {
              if (response) {
                if (response.data.status.isOK()) {
                  this.$snackbar.success(i18n.t("Supplier.syncWithKingdee"));
                }
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
      else
        YywdMiddleware.addJob({
          event: "sync_suppliers",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Supplier.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncThirdSupplier() {
      this.$store.dispatch("fullscreenLoading");
      Suppliers.syncThirdSupplier()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("Supplier.syncThirdSupplier"));
              this.getSupplierFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      );
    },
    exports() {
      if (this.settings && !this.settings.supplier_expire_show_flg) {
        delete this.options.licence_date;
      }
      Suppliers.exports(this.options);
    },
    syncYongYouData() {
      Suppliers.syncYongYouData().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.YongYouDataDialog = true;
          }
        }.bind(this)
      );
    },
  },
  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    settings: {
      handler() {
        if (this.settings && !this.settings.supplier_expire_show_flg) {
          delete this.options.licence_date;
        }
      },
    },
    options: {
      deep: true,
      handler() {
        this.getSupplierFromAPI();
        sessionStorage.setItem(
          "suppliers-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace("/supplier?id=" + this.currentItem.id);
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/supplier");
        }
      },
    },
    // 高级搜索
    // stocksContainersSelected: {
    //   handler() {
    //     this.options.container_category_code = this.stocksContainersSelected
    //       ? this.stocksContainersSelected.category_code
    //       : "";
    //     sessionStorage.setItem(
    //       "stocks-stocksContainersSelected",
    //       JSON.stringify(this.stocksContainersSelected)
    //     );
    //   },
    // },
  },
};
</script>

<style>
</style>